// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"18":"efa716d5","93":"abae69de","742":"0e40c55a"}[chunkId] + ".css";
};